import { Article, FilterBy } from './types'

export const toArticle = (article: any): Article => {
  const { attributes } = article
  const src = attributes?.src?.data?.attributes?.url
  const alt =
    attributes?.src?.data?.attributes?.alternativeText ||
    attributes?.src?.data?.attributes?.name
  const tags = attributes?.tags?.data?.map((tag: any) => tag?.attributes?.value)
  const author = attributes?.author?.data?.attributes

  return {
    id: article?.id,
    title: attributes?.title,
    content: attributes?.content,
    excerpt: attributes?.excerpt,
    alt,
    src,
    tags,
    filterBy: attributes?.filterBy as FilterBy,
    publishedAt: attributes?.publishedAt,
    about: attributes?.about,
    slug: attributes?.slug,
    amountVisitors: Number(attributes?.amountVisitors || 0),
    author: {
      title: author?.title,
      name: author?.name,
      role: author?.role,
      avatar: author?.avatar?.data?.attributes?.url,
    },
  } as Article
}
